import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENTS = {
  NAME: 'gaEvent',
  CATEGORY: 'Onboarding',
  ACTIONS: {
    ACCESS_ONBOARDING: 'Acesso ao Onboarding',
    ACCESS_WORDPRESS_IA: 'Acesso fluxo WordPress com IA',
    ACCESS_WORDPRESS_DEFAULT: 'Acesso fluxo WordPress',
    ACCESS_SITEBUILDER: 'Acesso fluxo Criador de Sites',
    ACCESS_SITEBUILDER_V2: 'Clique no Botão - Quero este',
    ACCESS_SITEBUILDER_V2_BANNER: 'Clique no Botão - Quero este',
    ACCESS_OTHER_TOOLS: 'Acesso fluxo Outras Ferramentas',
    WORDPRESS_EDIT: 'WordPress - Editar',
    WORDPRESS_CANCEL: 'WordPress - Cancelar',
    WORDPRESS_GO_BACK_STEP_1: 'WordPress - Voltar Etapa 1',
    WORDPRESS_GO_FORWARD_STEP_1: 'WordPress - Avançar Etapa 1',
    WORDPRESS_USER: 'WordPress - Usuário',
    WORDPRESS_PASSWORD: 'WordPress - Senha',
    WORDPRESS_GO_BACK_STEP_2: 'WordPress - Voltar Etapa 2',
    WORDPRESS_GO_FORWARD_STEP_2: 'WordPress - Avançar Etapa 2',
    WORDPRESS_PORTAL_BUTTON: 'WordPress - Portal do Cliente',
    WORDPRESS_START_NOW: 'WordPress - Começar Agora',
    WORDPRESS_IA_EDIT_TEMPORARY_DOMAIN: 'WordPress com IA - Editar',
    WORDPRESS_IA_CANCEL_TEMPORARY_DOMAIN_EDIT: 'WordPress com IA - Cancelar',
    WORDPRESS_IA_GO_BACK_STEP_1: 'WordPress com IA - Voltar Etapa 1',
    WORDPRESS_IA_GO_FORWARD_STEP_1: 'WordPress com IA - Avançar Etapa 1',
    WORDPRESS_IA_USER_FIELD: 'WordPress com IA - Usuário',
    WORDPRESS_IA_PASSWORD_FIELD: 'WordPress com IA - Senha',
    WORDPRESS_IA_GO_BACK_STEP_2: 'WordPress com IA - Voltar Etapa 2',
    WORDPRESS_IA_GO_FORWARD_STEP_2: 'WordPress com IA - Avançar Etapa 2',
    WORDPRESS_IA_PORTAL_BUTTON: 'WordPress com IA - Portal do Cliente',
    WORDPRESS_IA_START_NOW: 'WordPress com IA - Começar agora',
    SITEBUILDER_GO_BACK_STEP_1: 'Criador de Sites - Voltar Etapa 1',
    SITEBUILDER_GO_FORWARD_STEP_1: 'Criador de Sites - Avançar Etapa 1',
    SITEBUILDER_PORTAL_BUTTON: 'Criador de Sites - Portal do Cliente',
    SITEBUILDER_START_NOW: 'Criador de Sites - Começar agora',
    OTHER_TOOLS_EDIT_TEMPORARY_DOMAIN: 'Outras Ferramentas - Editar',
    OTHER_TOOLS_CANCEL_TEMPORARY_DOMAIN_EDIT: 'Outras Ferramentas - Cancelar',
    OTHER_TOOLS_GO_BACK_STEP_1: 'Outras Ferramentas - Voltar Etapa 1',
    OTHER_TOOLS_GO_FORWARD_STEP_1: 'Outras Ferramentas - Avançar Etapa 1',
    OTHER_TOOLS_ACCESS_CPANEL: 'Outras Ferramentas - Acessar cPanel',
    OTHER_TOOLS_EXPLORE_SOFTACULOUS: 'Outras Ferramentas - Explorar Softaculous',
    OTHER_TOOLS_FTP_ACCESS_DATA: 'Outras Ferramentas - Dados de acesso FTP',
    OTHER_TOOLS_PORTAL_BUTTON: 'Outras Ferramentas - Portal do Cliente',
    OTHER_TOOLS_START_NOW: 'Outras Ferramentas - Começar agora',
    CHOOSE_CREATE_SITE_OPTION: 'Portal - Seleção - Criar site',
    CHOOSE_MIGRATE_SITE_OPTION: 'Portal - Seleção - Migrar Site WordPress',
    DO_IT_LATER: 'Portal - Seleção - Criar ou Migrar site depois',
    SELECT_SITEBUILDER: 'Portal - Builder - Criar com Criador de Sites',
    SELECT_WORDPRESS: 'Portal - Builder - Criar com WordPress',
    SELECT_WORDPRESS_IA: 'Portal - Builder - Criar com WordPress com IA',
    SELECT_OTHER_TOOLS: 'Portal - Builder - Criar com modo avançado',
    SELECT_ANOTHER_DOMAIN: 'Portal - domínio - Quero usar outro domínio ou subdominio',
    SELECT_TEMPORARY_DOMAIN: 'Portal - domínio - Usar um domínio temporário',
    SELECT_DOMAIN_CONTINUE: 'Portal - domínio - Continuar',
    WORDPRESS_LOGIN: 'Portal - Login - Continuar ',
    WORDPRESS_SUCCESS_CONTINUE: 'Portal - Tudo pronto - Começar agora',
    WORDPRESS_SUCCESS_PORTAL: 'Portal - Tudo pronto - Portal do Cliente',
  },
  LABELS: {
    CREATE_WORDPRESS_IA: 'Criar site WordPress com IA',
    CREATE_WORDPRESS_DEFAULT: 'Criar site WordPress',
    CREATE_SITEBUILDER: 'Criador de Sites',
    CREATE_SITEBUILDER_V2: 'Card Novo Criador de Site com IA',
    CREATE_SITEBUILDER_V2_BANNER: 'Onboarding - Novo Criador de Site com IA',
    CREATE_OTHER_TOOLS: 'Outras Ferramentas',
    EDIT_TEMPORARY_DOMAIN: 'Editar Domínio Temporário',
    CANCEL_TEMPORARY_DOMAIN_EDIT: 'Cancelar edição do domínio temporário',
    GO_BACK_STEP: 'Voltar para etapa anterior',
    GO_FORWARD_STEP: 'Avançar para próxima etapa',
    USER_FIELD: 'Preenchimento no campo usuário',
    PASSWORD_FIELD: 'Preenchimento do campo senha',
    CREATE_OR_MIGRATE: 'Criar ou Migrar',
    BUILDER_SELECTION: 'Seleção Builder',
    SELECT_DOMAIN: 'Escolha de domínio',
    WORDPRESS_LOGIN: 'Criar Login',
    WORDPRESS_SUCCESS: 'Tudo pronto',
  },
};

const accessOnboarding = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_ONBOARDING,
    gaEventLabel: '',
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_ONBOARDING,
    label: '',
  });
};

const accessWordpressIA = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_WORDPRESS_IA,
    gaEventLabel: EVENTS.LABELS.CREATE_WORDPRESS_IA,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_WORDPRESS_IA,
    label: EVENTS.LABELS.CREATE_WORDPRESS_IA,
  });
};

const accessWordpressDefault = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_WORDPRESS_DEFAULT,
    gaEventLabel: EVENTS.LABELS.CREATE_WORDPRESS_DEFAULT,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_WORDPRESS_DEFAULT,
    label: EVENTS.LABELS.CREATE_WORDPRESS_DEFAULT,
  });
};

const accessSitebuilder = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER,
  });
};

const accessSitebuilderV2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER_V2,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2,
    label: EVENTS.LABELS.CREATE_SITEBUILDER_V2,
  });
};

const accessSitebuilderV2Banner = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2_BANNER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER_V2_BANNER,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2_BANNER,
    label: EVENTS.LABELS.CREATE_SITEBUILDER_V2_BANNER,
  });
};

const accessOtherTools = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_OTHER_TOOLS,
    gaEventLabel: EVENTS.LABELS.CREATE_OTHER_TOOLS,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_OTHER_TOOLS,
    label: EVENTS.LABELS.CREATE_OTHER_TOOLS,
  });
};

const wordpressEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_EDIT,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const wordpressCancel = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_CANCEL,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const wordpressGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressUser = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_USER,
    gaEventLabel: EVENTS.LABELS.USER_FIELD,
  });
};

const wordpressPassword = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_PASSWORD,
    gaEventLabel: EVENTS.LABELS.PASSWORD_FIELD,
  });
};

const wordpressGoBackStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_BACK_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressGoForwardStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_FORWARD_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const wordpressStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_START_NOW,
    gaEventLabel: '',
  });
};

const wordpressIaEditTempDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_EDIT_TEMPORARY_DOMAIN,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const wordpressIaCancelTempDomainEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_CANCEL_TEMPORARY_DOMAIN_EDIT,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const wordpressIaGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressIaGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressIaUserField = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_USER_FIELD,
    gaEventLabel: EVENTS.LABELS.USER_FIELD,
  });
};

const wordpressIaPasswordField = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_PASSWORD_FIELD,
    gaEventLabel: EVENTS.LABELS.PASSWORD_FIELD,
  });
};

const wordpressIaGoBackStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_BACK_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressIaGoForwardStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_FORWARD_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressIaPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const wordpressIaStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_START_NOW,
    gaEventLabel: '',
  });
};

const sitebuilderGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const sitebuilderGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const sitebuilderPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const sitebuilderStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_START_NOW,
    gaEventLabel: '',
  });
};

const otherToolsEditTempDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_EDIT_TEMPORARY_DOMAIN,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const otherToolsCancelTempDomainEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_CANCEL_TEMPORARY_DOMAIN_EDIT,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const otherToolsGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const otherToolsGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const otherToolsAccessCpanel = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_ACCESS_CPANEL,
    gaEventLabel: '',
  });
};

const otherToolsExploreSoftaculous = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_EXPLORE_SOFTACULOUS,
    gaEventLabel: '',
  });
};

const otherToolsFtpAccessData = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_FTP_ACCESS_DATA,
    gaEventLabel: '',
  });
};

const otherToolsPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const otherToolsStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_START_NOW,
    gaEventLabel: '',
  });
};

const chooseCreateSiteOption = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.CHOOSE_CREATE_SITE_OPTION,
    gaEventLabel: EVENTS.LABELS.CREATE_OR_MIGRATE,
  });
};

const chooseMigrateSiteOption = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.CHOOSE_MIGRATE_SITE_OPTION,
    gaEventLabel: EVENTS.LABELS.CREATE_OR_MIGRATE,
  });
};

const doItLater = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.DO_IT_LATER,
    gaEventLabel: EVENTS.LABELS.CREATE_OR_MIGRATE,
  });
};

const selectSitebuilder = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_SITEBUILDER,
    gaEventLabel: EVENTS.LABELS.BUILDER_SELECTION,
  });
};

const selectWordpress = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_WORDPRESS,
    gaEventLabel: EVENTS.LABELS.BUILDER_SELECTION,
  });
};

const selectWordpressIA = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_WORDPRESS_IA,
    gaEventLabel: EVENTS.LABELS.BUILDER_SELECTION,
  });
};

const selectOtherTools = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_OTHER_TOOLS,
    gaEventLabel: EVENTS.LABELS.BUILDER_SELECTION,
  });
};

const selectAnotherDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_ANOTHER_DOMAIN,
    gaEventLabel: EVENTS.LABELS.SELECT_DOMAIN,
  });
};

const selectTemporaryDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_TEMPORARY_DOMAIN,
    gaEventLabel: EVENTS.LABELS.SELECT_DOMAIN,
  });
};

const selectDomainContinue = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SELECT_DOMAIN_CONTINUE,
    gaEventLabel: EVENTS.LABELS.SELECT_DOMAIN,
  });
};

const wordpressLogin = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_LOGIN,
    gaEventLabel: EVENTS.LABELS.WORDPRESS_LOGIN,
  });
};

const wordpressSuccessContinue = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_SUCCESS_CONTINUE,
    gaEventLabel: EVENTS.LABELS.WORDPRESS_SUCCESS,
  });
};

const wordpressSuccessPortal = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_SUCCESS_PORTAL,
    gaEventLabel: EVENTS.LABELS.WORDPRESS_SUCCESS,
  });
};


const analytics = {
  initialStep: {
    accessOnboarding,
    accessWordpressIA,
    accessWordpressDefault,
    accessSitebuilder,
    accessSitebuilderV2,
    accessSitebuilderV2Banner,
    accessOtherTools,
    chooseCreateSiteOption,
    chooseMigrateSiteOption,
    doItLater,
  },
  chooseDomain: {
    selectAnotherDomain,
    selectTemporaryDomain,
    selectDomainContinue,
  },
  wordpressIa: {
    editTempDomain: wordpressIaEditTempDomain,
    cancelTempDomain: wordpressIaCancelTempDomainEdit,
    goBackStep1: wordpressIaGoBackStep1,
    goForwardStep1: wordpressIaGoForwardStep1,
    user: wordpressIaUserField,
    password: wordpressIaPasswordField,
    goBackStep2: wordpressIaGoBackStep2,
    goForwardStep2: wordpressIaGoForwardStep2,
    portalButton: wordpressIaPortalButton,
    startNow: wordpressIaStartNow,
    select: selectWordpressIA,
  },
  wordpressDefault: {
    editTempDomain: wordpressEdit,
    cancelTempDomain: wordpressCancel,
    goBackStep1: wordpressGoBackStep1,
    goForwardStep1: wordpressGoForwardStep1,
    user: wordpressUser,
    password: wordpressPassword,
    goBackStep2: wordpressGoBackStep2,
    goForwardStep2: wordpressGoForwardStep2,
    portalButton: wordpressPortalButton,
    startNow: wordpressStartNow,
    select: selectWordpress,
    login: wordpressLogin,
    successContinue: wordpressSuccessContinue,
    successGoToPortal: wordpressSuccessPortal,
  },
  sitebuilder: {
    goBackStep1: sitebuilderGoBackStep1,
    goForwardStep1: sitebuilderGoForwardStep1,
    portalButton: sitebuilderPortalButton,
    startNow: sitebuilderStartNow,
    select: selectSitebuilder,
  },
  otherTools: {
    editTempDomain: otherToolsEditTempDomain,
    cancelTempDomain: otherToolsCancelTempDomainEdit,
    goBackStep1: otherToolsGoBackStep1,
    goForwardStep1: otherToolsGoForwardStep1,
    cpanelCta: otherToolsAccessCpanel,
    softaculousCta: otherToolsExploreSoftaculous,
    ftpCta: otherToolsFtpAccessData,
    portalButton: otherToolsPortalButton,
    startNow: otherToolsStartNow,
    select: selectOtherTools,
  },
};

export default analytics;
